import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=fefd8cae&scoped=true&"
import script from "./PlayButton.vue?vue&type=script&lang=ts&"
export * from "./PlayButton.vue?vue&type=script&lang=ts&"
import style0 from "./PlayButton.vue?vue&type=style&index=0&id=fefd8cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefd8cae",
  null
  
)

export default component.exports